import {
  isResponsePending,
  isResponseSuccessful,
} from "@onestore/onestore-store-common/http"
import { Price } from "@core/price"
import { get } from "lodash"
import type { PriceValue } from "../../lib/api/basket"
import { BASKET_STATUS } from "./basket/constants"
import type { AppState } from "./reducer"

export const isBasketLoading = (state: AppState): boolean =>
  isResponsePending(get(state, ["basket", "request_state"]))

export const isBasketDone = (state: AppState): boolean =>
  isResponseSuccessful(get(state, ["basket", "request_state"]))

export const getBasketItemsCount = (state: AppState): number =>
  get(state, ["basket", "items_count"])

export const getBasketVatValue = (state: AppState): number =>
  get(state, ["basket", "vatValue"], 0)

export const getBasketSavings = (state: AppState): PriceValue =>
  get(state, ["basket", "savings"], Price.zero())

export const getBasketNotArchived = (state: AppState): boolean =>
  state.basket &&
  isResponseSuccessful(state.basket.request_state) &&
  BASKET_STATUS.ARCHIVED !== state.basket.status

export const getPromoCode = (state: AppState): string | undefined =>
  state.basket.promo_code

export const getUserDataReady = (state: AppState): boolean =>
  state.basket.userDataReady
